import GallectionGrid from './GallectionGrid';

export default GallectionGrid;
